import axios from "axios";
import { store } from "./../redux/store";

const baseInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

baseInstance.defaults.headers.common["Accept"] = "application/json";
baseInstance.defaults.headers.common["Content-Type"] = "application/json";

// request interceptor
baseInstance.interceptors.request.use((config) => {
  const {
    auth: { token },
  } = store.getState();
  if (token) {
    config.headers.authorization = "Bearer " + token;
  }
  return config;
});

// response interceptor
baseInstance.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      if (err?.config?.url !== "/auth/login" && err?.config?.url !== "/auth/changePassword") {
        window.location.reload();
      }
      localStorage.clear();
    }
    throw err;
  }
);

export default baseInstance;
